/**************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/
import React from 'react';

import EmptyMessage from './EmptyMessage';
import isProduct from '../../utils/isProduct';
import { AdminCategoryCard, AdminConfigCard, AdminProductCard } from './Cards';

export const renderItem = item => {
    if (item.__typename === 'Configuration') {
        return <AdminConfigCard item={item} />;
    }

    if (item.__typename === 'CategoryTree') {
        return <AdminCategoryCard item={item} />;
    }

    if (isProduct(item.__typename)) {
        return <AdminProductCard item={item} />;
    }

    return <></>;
};

export const renderEmptyView = () => {
    return <EmptyMessage />;
};
